<template>
	<div>
		<div class="Container" ref="container" :style="style">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		props: {
			active: Boolean,
			duration: {
				type: Number,
				default: 500
			}
		},
		data() {
			return {
				maxHeight: 0
			};
		},
        beforeMount() {
            this.toggleSlide(false);
        },
        mounted() {
            this.toggleSlide(this.active);
        },
		computed: {
			style () {
				return {
					height: this.maxHeight + 'px',
					'transition-duration': this.duration + 'ms'
				}
			}
		},
		watch: {
			active (active) {
				this.toggleSlide(active);
			}
		},
        methods: {
            toggleSlide(active) {
                const { container } = this.$refs;
                if (active) {
                    const style = container.getAttribute('style');
                    container.removeAttribute('style');
                    this.maxHeight = container.offsetHeight;
                    container.setAttribute('style', style);

                    // call this explicitely to force a new layout
                    container.offsetHeight;
                } else {
                    this.maxHeight = 0
                }
            },
        }
	};
</script>

<style scoped>
	.Container {
		overflow: hidden;
		transition-property: all
	}
</style>